async function loadConfig() {
  try {
    const response = await fetch("/config/config.json")
    const config = await response.json()
    window.env = {
      API_URL: config.VITE_API_URL,
      UI_URL: config.VITE_UI_URL,
      MYFORTERRO_API_URL: config.VITE_MYFORTERRO_API_URL,
      API_VERSION: config.VITE_API_VERSION,
      AUTH_URL: config.VITE_AUTH_URL,
      AUTH_CLIENT_ID: config.VITE_AUTH_CLIENT_ID,
      AUTH_REDIRECT_URI: config.VITE_AUTH_REDIRECT_URI,
      LOGOUT_REDIRECT_URI: config.VITE_LOGOUT_REDIRECT_URI,
      AUTH_SCOPE: config.VITE_AUTH_SCOPE,
      MAINTENANCE_MODE: config.MAINTENANCE_MODE,
      FARO_ENABLED: config.FARO_ENABLED,
      FARO_URL: config.FARO_URL,
      FARO_API_KEY: config.FARO_API_KEY,
      PLAUSIBLE_ENABLED: config.PLAUSIBLE_ENABLED,
      POSTHOG_KEY: config.POSTHOG_KEY,
      POSTHOG_HOST: config.POSTHOG_HOST,
      ANALYTICS_ENABLED: config.ANALYTICS_ENABLED,
      TOLGEE_SUGGESTION_ENABLED: config.TOLGEE_SUGGESTION_ENABLED,
      TOLGEE_API_URL: config.TOLGEE_API_URL,
      TOLGEE_API_KEY: config.TOLGEE_API_KEY,
      TOLGEE_API_KEY_CHAT: config.TOLGEE_API_KEY_CHAT,
    }
  } catch (error) {
    console.error("Failed to load configuration:", error)
  }
}

loadConfig().then(() => {
  import("./main")
})
